import {
  setAffiliateList,
  setJohnDeereFields,
  setJohnDeereWorkPlans,
} from 'affiliates';
import { setFVFieldsForWorkPlans } from 'export-selector';

export const processAffiliateList = ({ dispatch, affiliateList }) => {
  dispatch(setAffiliateList(affiliateList));
  return Promise.resolve(affiliateList);
};

export const processJohnDeereFields = async ({ dispatch, johnDeereFields }) => {
  dispatch(setJohnDeereFields(johnDeereFields));

  const selectedFvFields = Object.values(johnDeereFields.fields.byId)
  .filter(({ fvFieldUuid }) => fvFieldUuid)
  .map(({ fvFieldUuid }) => [fvFieldUuid, true]);

  dispatch(setFVFieldsForWorkPlans(Object.fromEntries(selectedFvFields)));
  return johnDeereFields;
};

export const processJohnDeereWorkPlans = async ({
  dispatch,
  johnDeereWorkPlans,
}) => {
  dispatch(setJohnDeereWorkPlans(johnDeereWorkPlans));
  return johnDeereWorkPlans;
};
